import {useInitializeFundamentalTheme} from './initializeFundamentalTheme'

/**
 * Should be used inside ThemeProvider
 * This component is used to initialize the fundamental theme of the application
 */
export const FundamentalThemeInitializer: React.FC = () => {
  useInitializeFundamentalTheme()
  return null
}
